import React from 'react';
import styled from '@emotion/styled';
import { get } from '../../../utils/shared/api';
import { handleError } from '../../utils/errors';
import formatRecData from './recommendation_mapper';
import TopicRecommendation from './topic_recommendation';
import ContentRefreshRecommendation from './content_refresh_recommendation';
import InternalTrafficRecommendation from './internal_traffic_recommendation';
import LowFinishRateRecommendation from './low_finish_rate_recommendation';
import FormatRecommendation from './format_recommendation';

const RecHeadline = styled('h3')`
  margin-bottom: 25px;
  color: #666;
`;

const RecMap = {
  TopicRecommendation,
  ContentRefreshRecommendation,
  InternalTrafficRecommendation,
  LowFinishRateRecommendation,
  FormatRecommendation
};

export default class RecommendationsContainer extends React.Component {
  constructor(props) {
    super(props);

    const { brandProfileId } = JSON.parse(props.appData);
    this.state = { brandProfileId };
  }

  componentDidMount() {
    const { brandProfileId } = this.state;

    return get(`/api/v1/brand_profiles/${brandProfileId}/strategic_recommendations`)
      .then(data => {
        this.setState({
          recData: data.map(rec => formatRecData(rec))
        });
      })
      .catch(error => {
        handleError(error);
      });
  }

  renderRecs() {
    const { recData } = this.state;

    return recData.map(rec => {
      const RecType = RecMap[rec.type];
      return <RecType key={rec.id} rec={rec} />;
    });
  }

  render() {
    const { recData } = this.state;

    if (!recData || !recData.length) return null;

    return (
      <div>
        <RecHeadline>Strategic recommendations</RecHeadline>
        {this.renderRecs()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/app/components/recommendations/recommendations_container.jsx